<template>
    <div class="modal-card" style="width:auto">
        <header class="modal-card-head">
            <p class="modal-card-title">Select Item Type</p>
        </header>
        <section class="modal-card-body">
          <v-list>
            <v-list-item @click="emitType(type)" v-for="type of typeList" :key="type">
              <v-list-item-content>
                  <v-list-item-title>{{ type }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
          </v-list>
        </section>
    </div>
</template>

<script>
export default {
  name: 'ItemTypeSelect',
  props: ['selectFn'],
  data: () => {
    return {
      typeList: null
    }
  },
  methods: {
    emitType (type) {
      this.selectFn(type)
      this.$parent.close()
    }
  },
  mounted: function () {
    if (this.$store.state.uid === 'WhKavRJRdnPDB9sZpVG6tG5veIu1') {
      this.typeList = ['Rates', 'PDF', 'URL']
    } else {
      this.typeList = ['Image', 'Video', 'URL', 'Arrivals', 'Departures', 'Clock', 'Youtube', 'Weather', 'AirQuality']
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/playlists/items/ItemTypeSelect.vue